import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Paths where the bottom navigation should be displayed
const SHOW_NAVIGATION_PATHS = [
  '/flowers',
  '/fruits',
  '/cat-grass',
  '/subscriptions',
  '/subscription-management',
  '/me',
  '/delivery-activity',
  '/billing-history',
  '/refund-history',
  '/upcoming-services',
];

export default function useBottomNavPadding() {
  const location = useLocation();
  const currentPath = location.pathname;
  
  useEffect(() => {
    // Check if navigation should be shown on current page
    const shouldShowNavigation = SHOW_NAVIGATION_PATHS.some(path => 
      currentPath.includes(path) || currentPath === path
    );
    
    // Add padding to main content when navigation is visible
    const mainElement = document.querySelector('main');
    if (mainElement && shouldShowNavigation) {
      mainElement.classList.add('pb-16');
    } else if (mainElement) {
      mainElement.classList.remove('pb-16');
    }
    
    return () => {
      // Cleanup on unmount
      if (mainElement) {
        mainElement.classList.remove('pb-16');
      }
    };
  }, [currentPath]);
} 